var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Cube.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Cube = ({
  color = '#353B60',
  opacity = '0.5',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.05",
    width: "24",
    height: "24",
    rx: "4",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    opacity: opacity,
    d: "M9.21801 15.8206L14.945 15.8028C15.3788 15.7997 15.8047 15.3738 15.8078 14.94L15.8256 9.213C15.8273 8.60316 15.4008 8.17665 14.7868 8.1742L9.05432 8.19743C8.62053 8.2005 8.19458 8.62645 8.19151 9.06024L8.17374 14.7872C8.17197 15.3971 8.6027 15.8278 9.21801 15.8206Z",
    fill: color
  })]
});